<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { onBeforeUnmount, watch } from 'vue';
import LaisPrimaryButton from '../LaisPrimaryButton.vue';

const props = defineProps({
  show: { type: Boolean, default: false },
  title: { type: String, default: 'Relatório de preço' },
  subtitle: { type: String, default: '' },
});

const emit = defineEmits(['close', 'cta-clicked']);
const titleId = 'pricing-report-modal-title';
let previousBodyOverflow = '';

const handleKeydown = event => {
  if (event.key === 'Escape') emit('close');
};

const lockBodyScroll = () => {
  if (typeof document === 'undefined') return;
  previousBodyOverflow = document.body.style.overflow;
  document.body.style.overflow = 'hidden';
  window.addEventListener('keydown', handleKeydown);
};

const unlockBodyScroll = () => {
  if (typeof document === 'undefined') return;
  document.body.style.overflow = previousBodyOverflow;
  window.removeEventListener('keydown', handleKeydown);
};

watch(
  () => props.show,
  isOpen => {
    if (isOpen) {
      lockBodyScroll();
    } else {
      unlockBodyScroll();
    }
  },
  { immediate: true }
);

onBeforeUnmount(unlockBodyScroll);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <Teleport to="body">
    <div
      v-if="show"
      class="fixed inset-0 z-[9999] flex bg-black/50 p-0 sm:items-center sm:justify-center sm:p-4"
      @click.self="emit('close')"
    >
      <section
        class="flex h-[100dvh] w-screen flex-col overflow-hidden bg-white shadow-lais-pop sm:h-auto sm:max-h-[90vh] sm:w-full sm:max-w-4xl sm:rounded-lais"
        role="dialog"
        aria-modal="true"
        :aria-labelledby="titleId"
      >
        <header
          class="sticky top-0 z-10 flex items-start justify-between gap-3 border-b border-lais-border-soft bg-white px-4 py-4 sm:px-5"
        >
          <div class="min-w-0">
            <h2
              :id="titleId"
              class="text-[18px] font-semibold text-lais-text font-redHatDisplay"
            >
              {{ title }}
            </h2>
            <p
              v-if="subtitle"
              class="mt-1 line-clamp-2 text-[13px] text-lais-text-muted"
            >
              {{ subtitle }}
            </p>
          </div>
          <button
            type="button"
            class="grid size-9 shrink-0 place-items-center rounded-full text-lais-text-muted hover:bg-lais-bg-muted"
            aria-label="Fechar relatório"
            @click="emit('close')"
          >
            <span class="i-lucide-x size-5" aria-hidden="true" />
          </button>
        </header>

        <div class="min-h-0 flex-1 overflow-y-auto px-4 py-4 sm:px-5">
          <slot />
        </div>

        <footer
          class="sticky bottom-0 z-10 flex flex-wrap justify-end gap-2 border-t border-lais-border-soft bg-white px-4 py-3 sm:px-5"
        >
          <LaisPrimaryButton
            variant="ghost"
            icon="i-lucide-message-circle"
            @click="emit('cta-clicked', { cta: 'support' })"
          >
            Falar com atendimento
          </LaisPrimaryButton>
          <LaisPrimaryButton variant="ghost" @click="emit('close')">
            Fechar
          </LaisPrimaryButton>
        </footer>
      </section>
    </div>
  </Teleport>
</template>
